var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 83,
    viewBox: "0 0 16 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M7.2929 82.7071C7.68342 83.0976 8.31659 83.0976 8.70711 82.7071L15.0711 76.3431C15.4616 75.9526 15.4616 75.3195 15.0711 74.9289C14.6805 74.5384 14.0474 74.5384 13.6569 74.9289L8 80.5858L2.34315 74.9289C1.95262 74.5384 1.31946 74.5384 0.928935 74.9289C0.538411 75.3195 0.538411 75.9526 0.928936 76.3431L7.2929 82.7071ZM7 4.37114e-08L7 82L9 82L9 -4.37114e-08L7 4.37114e-08Z",
    fill: "#005BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowDown);
export default __webpack_public_path__ + "static/media/longArrowDown.efae1f655d4c4c84456b50954f0cdf1b.svg";
export { ForwardRef as ReactComponent };